<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
export default {
    name: 'App',
    created () {
        this.resize()
    },
    methods: {
        resize () {
            var screenwidth = document.documentElement.clientWidth
            if (screenwidth > 500 && this.$route.name !== 'Tvlink') {
                var time = setTimeout(() => {
                    alert('建议用系统自带的Microsoft Edge浏览器、360极速浏览器、谷歌浏览器、火狐浏览器等非IE内核的浏览器') 
                }, 500);
            }
        }
    }
}
</script>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}
html, body {
    background: #f4f5f5;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // background: #409EFF;
}
</style>
